import React from 'react';
import {
  ToggleLabelStyled,
  ToggleStyled,
  ToggleSwitchStyled,
} from './Toggle.styled';
import ReactSwitch, { ReactSwitchProps } from 'react-switch';

/** 'ReactSwitch' cannot be used as a JSX component. */

type htmlInputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;
type excludedHTMLInputProps =
  | 'onFocus'
  | 'onBlur'
  | 'onKeyUp'
  | 'onChange'
  | 'ref'
  | keyof ReactSwitchProps;

type allowedHTMLinputProps = Omit<htmlInputProps, excludedHTMLInputProps>;

const Switch = ReactSwitch as unknown as React.ComponentType<
  ReactSwitchProps & allowedHTMLinputProps
>;
/** End of 'ReactSwitch' cannot be used as a JSX component. */

interface ToggleProps {
  isActive: boolean;
  label: string;
  onChange: () => void;
}

const Toggle = ({ isActive, label, onChange }: ToggleProps) => {
  return (
    <ToggleStyled>
      <ToggleLabelStyled>{label}</ToggleLabelStyled>
      <ToggleSwitchStyled>
        <span className="focus-ring" />
        <Switch
          data-id="panel-btn"
          onChange={onChange}
          width={56}
          height={32}
          handleDiameter={16}
          onColor="#00847d"
          offColor="#757575"
          onHandleColor="#fff"
          className="react-switch"
          uncheckedIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M17.657 7.75735L13.4143 12L17.657 16.2426L16.2428 17.6568L12.0001 13.4142L7.75748 17.6568L6.34326 16.2426L10.5859 12L6.34326 7.75735L7.75748 6.34314L12.0001 10.5858L16.2428 6.34314L17.657 7.75735Z"
                fill="white"
              />
            </svg>
          }
          checkedIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M9.99999 14.1428L7.33333 11.5714L6 13L10 17L18 8.99997L16.6667 7.57141L9.99999 14.1428Z"
                fill="white"
              />
            </svg>
          }
          checked={isActive}
        />
      </ToggleSwitchStyled>
    </ToggleStyled>
  );
};

export default Toggle;
